import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  deSelectAllListings,
  fetchUpcomingShifts,
  reStateUpComingShiftFilters,
  setLoading,
  toggleCandidateUpcomingFilter,
  updateUpComingShiftFilters,
  updateUpComingShiftPagination,
} from "@/reducers/clientcandidatedetail";

import ModalPopUp from "../../ModalPopUp";
import CalendarFilter from "../ListingFilters/CalendarFilter";
import FilterModalBottomAction from "../ListingFilters/FilterModalBottomAction";
import { FilterModalTop } from "../ListingFilters/FilterModalTop";
import TextFieldFilter from "../ListingFilters/TextFieldFilter";

const FilterModal = () => {
  const {
    upComingShiftShowFiltersModal,
    upComingShiftFilters,
    upComingShiftPagination,
    candidateDetails,
  } = useSelector((state) => state.clientCandidateDetail);
  const dispatch = useDispatch();

  const handleClose = (fromBtn = false) => {
    if (fromBtn) {
      dispatch(reStateUpComingShiftFilters());
    }
    dispatch(toggleCandidateUpcomingFilter(false));
  };

  // useEffect(() => {
  //     dispatch(fetchUpcomingShifts({ candidate_id: candidateDetails.candidate_id, }),);
  // }, []);

  const handleApply = () => {
    dispatch(
      updateUpComingShiftPagination({
        ...upComingShiftPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setLoading(true));
    dispatch(deSelectAllListings());
    dispatch(fetchUpcomingShifts(upComingShiftFilters));
    handleClose();
  };

  const handleReset = () => {
    dispatch(updateUpComingShiftFilters({}));
    dispatch(setLoading(true));
    dispatch(
      updateUpComingShiftPagination({
        ...upComingShiftPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(deSelectAllListings());
    dispatch(
      updateUpComingShiftFilters({
        search: upComingShiftFilters.search,
      }),
    );
    dispatch(
      fetchUpcomingShifts({ candidate_id: candidateDetails.candidate_id }),
    );
    handleClose();
  };

  return (
    <ModalPopUp
      show={upComingShiftShowFiltersModal}
      panelClass="max-w-[774px]"
      onClose={() => {
        handleClose(true);
      }}
    >
      <div className="grid gap-6">
        <div className="grid gap-[18px]">
          <div className="grix gap-4">
            <FilterModalTop
              handleClose={() => {
                handleClose(true);
              }}
            />
          </div>
          <div className="grid grid-cols-1 gap-x-6 gap-y-[18px] sm:grid-cols-2">
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(
                  updateUpComingShiftFilters({ contractReferenceNo: value }),
                );
              }}
              label="Contract Ref. No."
              value={upComingShiftFilters.contractReferenceNo}
              filterId="contractReferenceNo"
              placeholder="Enter Contract Ref. No."
            />
          </div>
          <div className="_filter_calendar">
            <CalendarFilter
              label="Shift Date (From - To)"
              dateFrom={upComingShiftFilters.bookedDateFrom}
              dateTo={upComingShiftFilters.bookedDateTo}
              handleChange={(value) => {
                dispatch(
                  updateUpComingShiftFilters({
                    bookedDateFrom: value.dateFrom,
                    bookedDateTo: value.dateTo,
                  }),
                );
              }}
            />
          </div>
        </div>
        <FilterModalBottomAction
          applyFunc={handleApply}
          resetFunc={handleReset}
        />
      </div>
    </ModalPopUp>
  );
};

export default FilterModal;
